export default __webpack_public_path__ + "static/media/EM1070.34I-39274_-23304_0.7d283f8b.jpg";